import React, { createContext, useContext, useState, useEffect } from 'react';

const ModeContext = createContext(null);

export function ModeProvider({ children }) {
  const [mode, setModeState] = useState(() => {
    const saved = localStorage.getItem('app_mode');
    return saved === 'sea' ? 'sea' : 'seo';
  });

  useEffect(() => {
    localStorage.setItem('app_mode', mode);
    // Update favicon color or page title hint
    document.title = mode === 'sea' ? 'Aegis SEA' : 'Aegis SEO';
  }, [mode]);

  const setMode = (m) => setModeState(m === 'sea' ? 'sea' : 'seo');
  const toggle = () => setModeState(m => m === 'seo' ? 'sea' : 'seo');

  return (
    <ModeContext.Provider value={{ mode, setMode, toggle, isSEO: mode === 'seo', isSEA: mode === 'sea' }}>
      {children}
    </ModeContext.Provider>
  );
}

export function useMode() {
  const ctx = useContext(ModeContext);
  if (!ctx) throw new Error('useMode must be used within ModeProvider');
  return ctx;
}
